/* cl-interactive: camada interativa do clone (Atelier -> Shrine). O scope remove todo <script>
   do concorrente; os hooks `on:click` / `on:change` do Atelier continuam no markup e sao
   atendidos aqui:
     1. carrosseis cl-slideshow-* (setas /previous /next, scroll-snap)
     2. acordeoes/FAQ: aria-expanded, fecha os irmaos (data-auto-close-details), Esc, clique fora
     3. grid de produtos: "Choose" abre o modal de quick-add (opcoes -> variante -> /cart/add);
        "Add" e o form /cart/add que a gaveta (cl-cart-drawer.js) intercepta
     4. colecao: filtros/ordenacao navegam com ?filter.*&sort_by= (filtro nativo do Shopify),
        "Clear"/"Clear all", colunas (product-grid-view) e a gaveta de filtros do mobile
   As regras de ESTADO (details[open], :hover...) estao em cl-interactive.css. */
(function () {
  if (window.__clInteractive) return; window.__clInteractive = true;
  var SCOPE = '[class*="cl-sec-"],[class*="cl-pdp"]';
  function inScope(el) { return !!(el && el.closest && el.closest(SCOPE)); }
  function hook(el, ev) { return el && el.closest ? el.closest('[on\\:' + ev + ']') : null; }

  /* ---------- 1. carrosseis ---------- */
  function scroller(comp) {
    return comp.querySelector(':scope > cl-slideshow-container > cl-slideshow-slides') || comp.querySelector('cl-slideshow-slides');
  }
  /* slide = <cl-slideshow-slide> OU qualquer filho marcado ref="slides[]" (cards do Atelier: div.clx-card) */
  function slides(sc) {
    return Array.prototype.filter.call(sc.children, function (e) {
      return (e.tagName === 'CL-SLIDESHOW-SLIDE' || e.getAttribute('ref') === 'slides[]') && e.offsetWidth > 0;
    });
  }
  function current(sc) {
    var s = slides(sc), best = 0, bd = 1e9, x = sc.getBoundingClientRect().left;
    s.forEach(function (el, i) { var d = Math.abs(el.getBoundingClientRect().left - x); if (d < bd) { bd = d; best = i; } });
    return best;
  }
  function go(comp, dir) {
    var sc = scroller(comp); if (!sc) return;
    var s = slides(sc); if (!s.length) return;
    var i = current(sc) + dir;
    var inf = comp.hasAttribute('infinite');
    var max = sc.scrollWidth - sc.clientWidth;
    if (dir > 0 && sc.scrollLeft >= max - 2) i = inf ? 0 : s.length - 1;      // fim da pista
    if (i >= s.length) i = inf ? 0 : s.length - 1;
    if (i < 0) i = inf ? s.length - 1 : 0;
    sc.scrollTo({ left: Math.min(max, s[i].offsetLeft - s[0].offsetLeft) });
    s.forEach(function (el, k) { el.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    sync(comp);
  }
  function sync(comp) {
    var sc = scroller(comp); if (!sc) return;
    var arr = comp.querySelector(':scope > cl-slideshow-container > cl-slideshow-arrows, cl-slideshow-arrows');
    if (!arr || comp.hasAttribute('infinite')) return;
    var p = arr.querySelector('.slideshow-control--previous'), n = arr.querySelector('.slideshow-control--next');
    var max = sc.scrollWidth - sc.clientWidth - 2;
    if (p) p.disabled = sc.scrollLeft <= 2;
    if (n) n.disabled = sc.scrollLeft >= max;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.slideshow-control--previous, .slideshow-control--next');
    if (!b) return;
    var comp = b.closest('cl-slideshow-component'); if (!comp) return;
    e.preventDefault(); e.stopPropagation();
    go(comp, b.classList.contains('slideshow-control--next') ? 1 : -1);
  }, true);
  document.addEventListener('scroll', function (e) {
    var t = e.target; if (t && t.tagName === 'CL-SLIDESHOW-SLIDES') { var c = t.closest('cl-slideshow-component'); if (c) sync(c); }
  }, true);

  /* ---------- 2. acordeoes / FAQ ---------- */
  function autoClose(d) { return d.hasAttribute('data-auto-close-details'); }
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d || d.tagName !== 'DETAILS' || !inScope(d)) return;
    var s = d.querySelector(':scope > summary');
    if (s) s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    if (d.open && autoClose(d)) {
      document.querySelectorAll('details[data-auto-close-details][open]').forEach(function (o) { if (o !== d && !o.contains(d)) o.open = false; });
    }
  }, true);
  document.addEventListener('click', function (e) {
    // clique fora fecha os paineis flutuantes (filtros/ordenacao)
    document.querySelectorAll('details[data-auto-close-details][open]').forEach(function (o) {
      if (!o.contains(e.target) && !(o.closest('dialog') && o.closest('dialog').contains(e.target))) o.open = false;
    });
  });
  // menu do rodape (details.menu__details): no Atelier fica sempre aberto, o clique nao fecha
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('details.menu__details > summary');
    if (s && inScope(s) && s.parentNode.open) e.preventDefault();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('cl-accordion-custom[data-close-with-escape] details[open], details[data-auto-close-details][open]').forEach(function (o) { o.open = false; });
  });

  /* ---------- 3. quick-add "Choose" -> modal ---------- */
  var QA = null, QAP = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, w) {
    if (!u) return '';
    u = typeof u === 'string' ? u : (u.src || '');
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 800);
  }
  function modal() {
    if (QA) return QA;
    QA = document.createElement('dialog');
    QA.className = 'cl-qa-modal';
    QA.setAttribute('data-cl-qa-modal', '');
    QA.setAttribute('aria-label', 'Quick add');
    QA.innerHTML = '<div class="cl-qa__box" data-cl-qa-box>' +
      '<div class="cl-qa__media" data-cl-qa-media></div>' +
      '<div class="cl-qa__details"><button type="button" class="cl-qa__close" data-cl-qa-close aria-label="Close">' +
      '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
      '<h2 class="cl-qa__title" data-cl-qa-title></h2>' +
      '<form action="/cart/add" method="post" class="cl-qa__form" data-cl-qa-form><div class="cl-qa__opts" data-cl-qa-opts></div>' +
      '<input type="hidden" name="id" value=""><input type="hidden" name="quantity" value="1">' +
      '<button type="submit" class="cl-qa__add" data-cl-qa-add>Add to Bag</button></form></div></div>';
    document.body.appendChild(QA);
    QA.addEventListener('click', function (e) {
      if (e.target === QA || e.target.closest('[data-cl-qa-close]')) { e.preventDefault(); closeQA(); return; }
      var o = e.target.closest('[data-cl-qa-opt]'); if (!o) return;
      e.preventDefault();
      var g = o.closest('[data-cl-qa-group]');
      g.querySelectorAll('[data-cl-qa-opt]').forEach(function (x) { x.setAttribute('aria-checked', x === o ? 'true' : 'false'); });
      pick();
    });
    // a gaveta intercepta o submit na CAPTURA do document e para a propagacao: o form nunca
    // ouviria o evento. A captura no window roda antes -> so fecha o modal (o POST e da gaveta)
    window.addEventListener('submit', function (e) { if (QA && e.target === QA.querySelector('[data-cl-qa-form]')) setTimeout(closeQA, 0); }, true);
    return QA;
  }
  function closeQA() { if (QA && QA.open) QA.close(); document.documentElement.classList.remove('cl-qa-lock'); }
  function selected() {
    return Array.prototype.map.call(QA.querySelectorAll('[data-cl-qa-group]'), function (g) {
      var o = g.querySelector('[data-cl-qa-opt][aria-checked="true"]'); return o ? o.getAttribute('data-value') : null;
    });
  }
  function match(p, sel) {
    return p.variants.filter(function (v) {
      var vo = v.options || [v.option1, v.option2, v.option3];
      return sel.every(function (x, i) { return x == null || vo[i] === x; });
    })[0];
  }
  function pick() {
    var p = QAP, sel = selected(), v = match(p, sel);
    // valor sem estoque na combinacao atual: marcado (como o Atelier), sem bloquear o clique
    QA.querySelectorAll('[data-cl-qa-group]').forEach(function (g, gi) {
      g.querySelectorAll('[data-cl-qa-opt]').forEach(function (o) {
        var s2 = sel.slice(); s2[gi] = o.getAttribute('data-value');
        var vv = match(p, s2);
        o.classList.toggle('is-unavailable', !vv || vv.available === false);
      });
    });
    var add = QA.querySelector('[data-cl-qa-add]');
    QA.querySelector('[name=id]').value = v ? v.id : '';
    add.disabled = !v || v.available === false;
    add.textContent = !v ? 'Unavailable' : (v.available === false ? 'Sold out' : 'Add to Bag');
    if (v && v.featured_image && v.featured_image.src) {
      var first = QA.querySelector('[data-cl-qa-media] img');
      if (first) first.src = img(v.featured_image.src, 800);
    }
  }
  function render(p) {
    QAP = p; modal();
    QA.querySelector('[data-cl-qa-title]').textContent = p.title;
    var v0 = p.variants.filter(function (v) { return v.available !== false; })[0] || p.variants[0];
    var vo = v0.options || [v0.option1, v0.option2, v0.option3];
    var imgs = (p.images || []).slice(0, 8);
    if (v0.featured_image && v0.featured_image.src) imgs = [v0.featured_image.src].concat(imgs.filter(function (u) { return u !== v0.featured_image.src; }));
    QA.querySelector('[data-cl-qa-media]').innerHTML = imgs.map(function (u, i) {
      return '<img src="' + esc(img(u, 800)) + '" alt="' + esc(p.title) + '" width="384" height="480" loading="' + (i ? 'lazy' : 'eager') + '">';
    }).join('');
    var single = p.variants.length === 1 && /default title/i.test(p.variants[0].title || '');
    QA.querySelector('[data-cl-qa-opts]').innerHTML = single ? '' : (p.options || []).map(function (o, i) {
      var name = typeof o === 'string' ? o : o.name, vals = (typeof o === 'string' ? null : o.values) || [];
      return '<fieldset class="cl-qa__group" data-cl-qa-group><legend class="cl-qa__legend">' + esc(name) + '</legend><div class="cl-qa__vals">' +
        vals.map(function (val) {
          return '<button type="button" class="cl-qa__opt" role="radio" data-cl-qa-opt data-value="' + esc(val) + '" aria-checked="' + (val === vo[i] ? 'true' : 'false') + '">' + esc(val) + '</button>';
        }).join('') + '</div></fieldset>';
    }).join('');
    pick();
    QA.showModal();
    document.documentElement.classList.add('cl-qa-lock');
  }
  function handleOf(card, btn) {
    var a = (btn && btn.getAttribute('href')) ? btn : card && card.querySelector('a[href*="/products/"]');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function openChoose(btn) {
    var card = btn.closest('cl-product-card') || btn.closest('li');
    var h = handleOf(card, btn); if (!h) return false;
    btn.setAttribute('aria-busy', 'true');
    fetch('/products/' + h + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (p) { btn.removeAttribute('aria-busy'); render(p); })
      .catch(function () { btn.removeAttribute('aria-busy'); location.href = '/products/' + h; });
    return true;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.quick-add__button--choose');
    if (!b || !inScope(b)) return;
    e.preventDefault(); e.stopPropagation();
    openChoose(b);
  }, true);

  /* ---------- 4. colecao: filtros, ordenacao, colunas, gaveta de filtros ---------- */
  function collPath(form) {
    if (/^\/collections\//.test(location.pathname)) return location.pathname;
    return (form && form.getAttribute('action')) || '/collections/all';
  }
  function params(root) {
    var p = new URLSearchParams();
    root.querySelectorAll('input[name^="filter."], select[name^="filter."]').forEach(function (i) {
      if ((i.type === 'checkbox' || i.type === 'radio') && !i.checked) return;
      if (i.disabled || !String(i.value).trim()) return;
      p.append(i.name, i.value.trim());
    });
    var s = root.querySelector('input[name="sort_by"]:checked') || document.querySelector(SCOPE.split(',').map(function (x) { return x + ' input[name="sort_by"]:checked'; }).join(','));
    if (s && s.value && s.value !== 'manual') p.set('sort_by', s.value);
    return p;
  }
  function navigate(root) {
    var form = root.querySelector('form') || root.closest('form');
    var qs = params(root).toString();
    location.assign(collPath(form) + (qs ? '?' + qs : ''));
  }
  var priceT = null;
  document.addEventListener('change', function (e) {
    var t = e.target; if (!inScope(t)) return;
    var h = hook(t, 'change'); if (!h) return;
    var act = h.getAttribute('on:change');
    if (act === 'results-list/updateLayout') {
      document.querySelectorAll(':is(' + SCOPE + ') [product-grid-view]').forEach(function (g) {
        g.setAttribute('product-grid-view', t.value === 'zoom-out' || t.value === 'mobile-single' ? t.value : 'default');
      });
      return;
    }
    var root = t.closest('cl-facets-form-component') || h.closest('cl-facets-form-component') || h;
    if (act === '/updatePriceFilterAndResults') { clearTimeout(priceT); priceT = setTimeout(function () { navigate(root); }, 400); return; }
    if (act === '/updateFilters' || act === '/updateFilterAndSorting') navigate(root);
  }, true);
  document.addEventListener('click', function (e) {
    var h = hook(e.target, 'click'); if (!h || !inScope(h)) return;
    var act = h.getAttribute('on:click'), root;
    if (act === '/clearFilter') {
      e.preventDefault();
      var box = h.closest('cl-facet-inputs-component, cl-price-facet-component');
      root = h.closest('cl-facets-form-component');
      if (box) box.querySelectorAll('input').forEach(function (i) { if (i.type === 'checkbox' || i.type === 'radio') i.checked = false; else i.value = ''; });
      if (root) navigate(root);
    } else if (act.indexOf('/removeFilter') === 0) {
      e.preventDefault();
      var s = document.querySelector(':is(' + SCOPE + ') input[name="sort_by"]:checked');
      location.assign(collPath(null) + (s && s.value !== 'manual' ? '?sort_by=' + encodeURIComponent(s.value) : ''));
    } else if (act === '#filters-drawer/open' || act === '#filters-drawer/close') {
      e.preventDefault();
      var d = document.querySelector('#filters-drawer dialog') || document.querySelector('dialog#filters-drawer');
      if (!d || !d.showModal) return;
      if (act.slice(-4) === 'open') { d.showModal(); d.classList.add('dialog--open'); document.documentElement.classList.add('cl-qa-lock'); }
      else { d.close(); d.classList.remove('dialog--open'); document.documentElement.classList.remove('cl-qa-lock'); }
    }
  }, true);
  // ordenacao: a opcao e um div role=option com o radio escondido dentro
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('.sorting-filter__option');
    if (!o || !inScope(o)) return;
    var i = o.querySelector('input[name="sort_by"]'); if (!i || i.checked) return;
    i.checked = true;
    i.dispatchEvent(new Event('change', { bubbles: true }));
  });
  // filtros vindos da URL: marca o que ja esta aplicado (o markup e estatico)
  function reflectUrl() {
    var q = new URLSearchParams(location.search); if (!q.toString()) return;
    document.querySelectorAll(':is(' + SCOPE + ') input[name^="filter."]').forEach(function (i) {
      var vals = q.getAll(i.name);
      if (i.type === 'checkbox' || i.type === 'radio') i.checked = vals.indexOf(i.value) > -1;
      else if (vals.length) i.value = vals[0];
    });
    var sb = q.get('sort_by');
    if (sb) document.querySelectorAll(':is(' + SCOPE + ') input[name="sort_by"]').forEach(function (i) {
      i.checked = i.value === sb;
      var opt = i.closest('.sorting-filter__option'); if (opt) opt.setAttribute('aria-selected', i.checked ? 'true' : 'false');
      if (i.checked) {
        var st = i.closest('details') && i.closest('details').querySelector('.facets__status');
        if (st) st.textContent = i.getAttribute('data-option-name') || st.textContent;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reflectUrl); else reflectUrl();

  /* ---------- 5. arraste com MOUSE nos carrosseis (operador: "todos os swipes devem
     funcionar por seta, arraste de mouse e toque"). Toque = scroll nativo com snap. ---------- */
  var DRAG = null, SUPPRESS = false;
  function dragTarget(el) {
    var sc = el.closest && el.closest('cl-slideshow-slides, [data-cl-drag]');
    return sc && inScope(sc) && sc.scrollWidth > sc.clientWidth + 2 ? sc : null;
  }
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var sc = dragTarget(e.target); if (!sc) return;
    DRAG = { sc: sc, x: e.clientX, left: sc.scrollLeft, moved: false, id: e.pointerId };
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (!DRAG || e.pointerId !== DRAG.id) return;
    var dx = e.clientX - DRAG.x;
    if (!DRAG.moved && Math.abs(dx) < 6) return;
    if (!DRAG.moved) { DRAG.moved = true; DRAG.sc.style.scrollSnapType = 'none'; DRAG.sc.style.scrollBehavior = 'auto'; DRAG.sc.classList.add('cl-dragging'); }
    DRAG.sc.scrollLeft = DRAG.left - dx;
    e.preventDefault();
  }, true);
  function endDrag(e) {
    if (!DRAG || (e && e.pointerId !== DRAG.id)) return;
    var d = DRAG; DRAG = null;
    if (!d.moved) return;
    SUPPRESS = true; setTimeout(function () { SUPPRESS = false; }, 50);
    d.sc.classList.remove('cl-dragging');
    // encaixa no slide mais proximo na direcao do arraste
    var kids = Array.prototype.filter.call(d.sc.children, function (k) { return k.offsetWidth > 0; });
    var base = kids.length ? kids[0].offsetLeft : 0, target = d.sc.scrollLeft, best = target, bd = 1e9;
    var dir = d.sc.scrollLeft > d.left ? 1 : -1;
    kids.forEach(function (k) {
      var pos = k.offsetLeft - base, dist = (pos - target) * dir;
      if (dist > -k.offsetWidth * 0.7 && Math.abs(pos - target) < bd) { bd = Math.abs(pos - target); best = pos; }
    });
    d.sc.style.scrollSnapType = ''; d.sc.style.scrollBehavior = '';
    d.sc.scrollTo({ left: best, behavior: 'smooth' });
    var comp = d.sc.closest('cl-slideshow-component'); if (comp) setTimeout(function () { sync(comp); }, 400);
  }
  document.addEventListener('pointerup', endDrag, true);
  document.addEventListener('pointercancel', endDrag, true);
  document.addEventListener('click', function (e) { if (SUPPRESS) { e.preventDefault(); e.stopPropagation(); } }, true);
  document.addEventListener('dragstart', function (e) { if (dragTarget(e.target)) e.preventDefault(); }, true);

  /* 5. faixa "As Seen In" (press marquee, home + PDPs). O @keyframes press-scroll do tema dele
     (`to{transform:translate(calc(-100% / var(--press-repeat)))}`) nao vem no extract — so
     regras que casam no DOM — e a faixa ficava PARADA (retrabalho 2026-09-30). Motor por rAF:
     desloca a trilha 1/--press-repeat da largura a cada --press-speed, em loop sem emenda
     (os .press__set sao copias); pausa fora da tela e com a aba escondida; arraste de mouse
     ou toque move a faixa. Escreve `translateX(Npx)` inline: o freeze do verify o estaciona. */
  function mqSecs(v) { v = String(v || '').trim(); var n = parseFloat(v); if (isNaN(n) || n <= 0) return 18; return /ms$/.test(v) ? n / 1000 : n; }
  function mqInit(track) {
    if (track.__clMq) return; track.__clMq = true;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var host = track.closest('.press') || track.parentNode, vp = track.parentNode;
    var cs = getComputedStyle(host);
    var rep = parseFloat(cs.getPropertyValue('--press-repeat')) || track.children.length || 2;
    var dur = mqSecs(cs.getPropertyValue('--press-speed')) * 1000;
    var x = 0, last = 0, onScreen = true, drag = null;
    track.style.animation = 'none';
    track.style.willChange = 'transform';
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; }).observe(vp);
    function frame(t) {
      var dt = last ? Math.min(t - last, 100) : 0; last = t;
      var loop = track.offsetWidth / rep;
      if (loop > 0) {
        if (!drag && onScreen && !document.hidden) x -= loop * dt / dur;
        while (x <= -loop) x += loop;
        while (x > 0) x -= loop;
        track.style.transform = 'translateX(' + x.toFixed(2) + 'px)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
    vp.style.touchAction = 'pan-y';
    vp.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      drag = { id: e.pointerId, sx: e.clientX, x0: x };
      try { vp.setPointerCapture(e.pointerId); } catch (_) {}
    });
    vp.addEventListener('pointermove', function (e) { if (drag && e.pointerId === drag.id) x = drag.x0 + (e.clientX - drag.sx); });
    function mqEnd(e) { if (drag && e.pointerId === drag.id) drag = null; }
    vp.addEventListener('pointerup', mqEnd);
    vp.addEventListener('pointercancel', mqEnd);
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function mqAll(root) { (root || document).querySelectorAll('.press__track').forEach(mqInit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mqAll(); }); else mqAll();
  document.addEventListener('shopify:section:load', function (e) { mqAll(e.target); });

  window.clInteractive = { go: go, quickAdd: openChoose, closeQuickAdd: closeQA };
})();
